import App from './App.vue'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import store from './store/store'
import router from './routes/router'
import { ValidationProvider } from 'vee-validate'
import { ValidationObserver } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'
import { datadogLogs } from '@datadog/browser-logs'
import { UserObj } from './store/modules/webchat'
import { injectChat } from './common/chat'
import { Store } from 'vuex'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import supportedIcons from './components/design-system/utils/supportedIcons'
import VTooltip from 'v-tooltip'

import ReactWrapper from './components/ReactWrapper.vue'

supportedIcons.map(icon => {
  library.add(icon)
})

if (process.env.VUE_APP_DATADOG_CLIENT_TOKEN !== undefined) {
  datadogLogs.init({
    clientToken: process.env.VUE_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: `vouch-bot-fe-${process.env.VUE_APP_ENVIRONMENT}`,
    forwardErrorsToLogs: true,
    sampleRate: 100,
  })
}

for (const [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation,
  })
}

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('react-wrapper', ReactWrapper)

Vue.config.productionTip = false
Vue.use(VTooltip)
Vue.use(Vuelidate)

const main = async () => {
  if (window.location.pathname !== '/entrust') {
    // Try to log the user in using the current authentication cookie, if any.
    await store.dispatch('user/tryAuthenticate')
  }

  const userObj: UserObj | undefined = store.getters['webchat/userObj']
  if (userObj !== undefined) {
    injectChat(userObj)
  }

  new Vue({
    store: store as unknown as Store<unknown>,
    router,
    render: h => h(App),
  }).$mount('#app')
}

main()
